import React from "react";
import { Button, createStyles, Dialog, makeStyles } from "@material-ui/core";
import { CalendarDialogIcon } from "icons";
import CloseIcon from "@material-ui/icons/Close";
import useText from "constants/text";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      textAlign: "center",
      width: "500px",
      padding: "60px",
      borderRadius: "9px",
    },
    text: {
      margin: "29px 0 35px",
      fontFamily: "Montserrat",
      fontSize: "14px",
      fontWeight: 600,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "1.79",
      letterSpacing: "normal",
      textAlign: "center",
      color: "#757a93",
    },
    button: {
      width: "59px",
      height: "43px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "center",
      padding: "13px 18px",
      borderRadius: "4px",
      backgroundColor: "#399ebf",
      color: "#fff",
      "&:hover": {
        backgroundColor: "#399ebf",
      },
    },
    closeIcon: {
      position: "absolute",
      right: "10px",
      top: "10px",
      cursor: "pointer",
    },
  })
);

interface HolidaysDialogProps {
  onClose: () => void;
}

const HolidaysDialog = ({ onClose }: HolidaysDialogProps) => {
  const styles = useStyles();
  const { text } = useText();
  return (
    <Dialog open>
      <CloseIcon onClick={onClose} className={styles.closeIcon} />
      <div className={styles.root}>
        <CalendarDialogIcon />
        <div className={styles.text}>
          {text.all.holidays_text} <br />
          {text.all.holidays_second_text}
        </div>
        <Button onClick={onClose} className={styles.button}>
          OK
        </Button>
      </div>
    </Dialog>
  );
};

export default HolidaysDialog;
